import { render, staticRenderFns } from "./receivedModal.vue?vue&type=template&id=62a0b6a4&scoped=true&"
import script from "./receivedModal.vue?vue&type=script&lang=js&"
export * from "./receivedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a0b6a4",
  null
  
)

export default component.exports